/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../index';

/**
 * @example
 *     {
 *         body: "string"
 *     }
 */
export interface PresentationSignRequest {
    /** All supported DID methods. Default is "web". */
    didMethod?: Truvity.PresentationSignRequestDidMethod;
    /** The unsigned presentation to sign. */
    body: string;
}
